module.exports = __webpack_public_path__ + "img/移除.449d9eec.png";